import { render } from "./AdminTest.vue?vue&type=template&id=b325764e"
import script from "./AdminTest.vue?vue&type=script&lang=js"
export * from "./AdminTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__